import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, FlameIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/salesContent';
import { trackInitiateCheckout } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  note?: string;
  pulse?: boolean;
  /** When set, the button scrolls to this section instead of going to checkout. */
  scrollToId?: string;
};
export function CtaButton({
  children,
  note,
  pulse = true,
  scrollToId
}: CtaButtonProps) {
  const reduceMotion = useReducedMotion();
  const shouldPulse = pulse && !reduceMotion;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!scrollToId) {
      trackInitiateCheckout();
      return;
    }
    const target = document.getElementById(scrollToId);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  };
  return <div className="flex w-full flex-col items-center" data-id="element-20" data-mp="35xfn13kluz8p">
      <motion.a href={scrollToId ? `#${scrollToId}` : CHECKOUT_URL} onClick={handleClick} animate={shouldPulse ? {
      scale: [1, 1.025, 1]
    } : undefined} transition={shouldPulse ? {
      duration: 2.4,
      ease: 'easeInOut',
      repeat: Infinity
    } : undefined} className="font-display group inline-flex w-full max-w-2xl items-center justify-center gap-3 rounded-lg bg-amber-400 px-5 py-4 text-center text-xl font-extrabold uppercase tracking-wide text-zinc-950 shadow-lg shadow-amber-400/15 transition-colors duration-150 ease-out hover:bg-amber-300 focus:outline-none focus-visible:ring-4 focus-visible:ring-amber-400/40 md:px-6 md:py-5 md:text-2xl" data-id="element-21" data-mp="35yqtjb5fql3i">
        <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-22" data-mp="6iao1tevm69a" />
        <span data-id="element-23" data-mp="bh3wv8j7x934">{children}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-24" data-mp="bi6ppm03pllo" />
      </motion.a>
      {note && <p className="mt-4 text-center text-sm text-zinc-400 md:text-base" data-id="element-25" data-mp="3mxgw8h530veg">{note}</p>}
    </div>;
}